<template>
  <div>
    <div class="mainform" ref="fullpage">
      <div v-if="message" class="message">
        <p v-html="message" />
      </div>
      <form method="post" ref="form" action="/api/mail.php">
        <div class="form-group">
          <input type="text" name="name" v-bind:placeholder="$t('home.contact.form.name')" required />
        </div>
        <div class="form-group">
          <input type="email" name="email" v-bind:placeholder="$t('home.contact.form.email')" required />
        </div>
        <div class="form-group">
          <input type="phone" name="phone" v-bind:placeholder="$t('home.contact.form.phone')" />
        </div>
        <div class="form-group">
          <textarea name="message" v-bind:placeholder="$t('home.contact.form.message')" required />
        </div>
        <div class="form-group text-left">
          <div class="d-flex checkbox_container flex-nowrap"><input class="flex-shrink" type="checkbox" name="policy" required><span v-html="$t('home.contact.form.policy')" /></div>
          <div class="d-flex checkbox_container flex-nowrap"><input type="checkbox" name="marketing"><span v-html="$t('home.contact.form.marketing')" /></div>
        </div>
        <div class="form-group">
          <FormButton v-bind:value="$t('home.contact.form.send')" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import FormButton from './FormButton'

function makeAjaxRequest(url, method, data, callback) {
  var XHR = new XMLHttpRequest();

  // Define what happens on successful data submission
  XHR.addEventListener('load', function(event) {
    callback(XHR);
  });

  // Define what happens in case of error
  XHR.addEventListener('error', function(event) {
    callback(XHR);
  });

  // Set up our request
  XHR.open(method, url);

  // Send our FormData object; HTTP headers are set automatically
  XHR.send(data);
}

function callbackHandler(httpRequest) {
    // response has been received so handle it now
}

export default {
  name: 'mainform',
  components: {
    FormButton    
  },
  data() {
    return {
      message: ''
    }
  },
  methods: {
    displayMessage(msg, status) {
      this.message = msg
      setTimeout(3000, () => { this.message = '' });
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$el.querySelector('[href="#policy"]').onclick = (e) => {
        document.querySelector('.iubenda-embed, .iubenda-nostyle').click()
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.$el.querySelector('[href="#policy"]').onclick = (e) => {
        document.querySelector('.iubenda-embed, .iubenda-nostyle').click()
      }
    });
    this.$refs.form.addEventListener('submit', (e) => {
      e.preventDefault();

      var form = this.$refs.form;
      var data = new FormData(form);
      var action = form.getAttribute("action");
      var method = form.getAttribute("method");
      makeAjaxRequest(action, method, data, (httpRequest) => {
        if (httpRequest.readyState === 4) {
          // of this will change accordingly
          if (httpRequest.status >= 200 && httpRequest.status < 400) {
            let resp = httpRequest.responseText;
            console.log(httpRequest.responseText);
            let data = JSON.parse(httpRequest.responseText);
            if (data['state']) {
              this.displayMessage(this.$t('home.contact.form.sent'), true);

              form.reset();
            } else if (data['missing']) {
              this.displayMessage(this.$t('home.contact.form.requiredfields'), false);
            } else {
              this.displayMessage(this.$t('home.contact.form.error'), false);
            }
          }
        } else {
          this.displayMessage(this.$t('home.contact.form.error'), false);
        }
      });
    });
  }
}
</script>


<style lang="scss">


</style>

<style scoped lang="scss">
  @import '~@/assets/scss/forms';

  form input:not([type="checkbox"]),
  form textarea,
  .button /deep/ input {
    width: 100%;
  }

  form input[type="checkbox"] {
    margin-right: 10px;
  }

  .form-group {
    margin-bottom: 40px;
  }

  .checkbox_container {
    font-size: 12px;
    color: $light-gray;
    margin-bottom: 5px;
  }

  textarea,
  input {
    background: transparent;
    border: none;
  }
  textarea,
  input:not([type="submit"]) {
    border-bottom: 1px solid black;
  }
</style>
